const constants = {
  address: "39 Perth, BF THAI, BF Homes, Las Piñas City, Philippines 1740",
  bir: "497-056-147",
  dti: "4683102",
  email: "renewableph@outlook.com",
  facebook: "https://www.facebook.com/RenewablePH",
  linkedin: "https://www.linkedin.com/company/renewable-philippines/",
  phone: "(+63) 917 903 9953",
};

export default constants;
